import 'react';
import InputField from './InputField';
import React, {useState} from 'react';

export default function PasswordField(props) {

    const [passwordVisible, setPasswordVisible] = useState(false);

    const containerStyles = {
        position: 'relative',
        width: '100%'
    }

    const buttonStyle = {
        position: 'absolute',
        top: '50%',
        right: 15,
        transform: 'translateY(-50%)',
        cursor: 'pointer',
        width: 20,
        height: 20,
        border: 'none',
        background: 'none',
        padding: 0,
        margin: 0,
    };

    const iconStyle = {
        width: '100%',
        height: '100%',
    };

    return <div style={containerStyles}>
        <InputField
            label="Password"
            type={passwordVisible ? 'text' : 'password'}
            required={true}
            {...props}
        >
            <button
                type="button"
                aria-label={passwordVisible ? 'Hide password' : 'Show password'}
                aria-pressed={passwordVisible}
                style={buttonStyle}
                onClick={() => setPasswordVisible(!passwordVisible)}
            >
                <img
                    src={passwordVisible ? '/images/icons/hide.svg' : '/images/icons/show.svg'}
                    alt={passwordVisible ? 'Hide password' : 'Show password'}
                    style={iconStyle}
                />
            </button>
        </InputField>
    </div>;
}